import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { illustrations } from '../assets/img/illustrations';

function NotFound() {
  const { t } = useTranslation('notfound');

  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center bg-white px-4 py-10">
      <div data-testid="not-found-content" className="text-center max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg">
        <img
          src={illustrations.notFound}
          alt=""
          aria-hidden="true"
          draggable="false"
          className="mx-auto w-44 h-44 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 max-w-full max-h-[40vh] object-contain select-none"
        />
        {/* The illustration already draws a large "404", so the heading steps
            down to a readable size instead of competing with it. */}
        <h1 data-testid="not-found-title" className="mt-4 text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D8A8A] tracking-tight">
          {t('notfound.title')}
        </h1>
        <p data-testid="not-found-message" className="mt-3 text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed">
          {t('notfound.message')}
        </p>
        <Link
          data-testid="back-to-home-link"
          to="/"
          className="mt-6 inline-block px-6 py-3 bg-[#4ABDBD] text-white rounded-lg transition text-sm sm:text-base font-semibold hover:opacity-90"
        >
          {t('notfound.back_button')}
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
